<assist-dropdownlist
  #dropdown
  (closed)="cancelled.emit(null)"
  (filterChange)="filterChanged($event)"
  (valueChange)="valueChanged($event)"
  [data]="resultsData$ | async"
  [filterable]="true"
  [popupSettings]="{
    appendTo: 'component',
    popupClass: '.zfix',
  }"
  style="width: 100%"
  textField="name"
  valueField="id"
>
  <ng-template fixedGroupTemplate let-group>
    <h3 class="break-words">{{ group | localizedString }}</h3>
  </ng-template>
  <ng-template groupTemplate let-group>
    <h3 class="break-words">{{ group | localizedString }}</h3>
  </ng-template>
  <ng-template fixedGroupTemplate itemTemplate let-item>
    @if (item.firstInGroup) {
      <h4 class="break-words">
        {{ item.typeName }}
      </h4>
    }

    <div class="cue-dropdown-image-text">
      <div class="image-wrapper xl">
        <img
          [class.!object-cover]="item.imagePreferCover"
          [ngStyle]="{
            'object-position': item.imageObjectPosition,
          }"
          [src]="item.imageUrl === null || item.imageUrl === '' ? 'assets/images/placeholder-order.svg' : item.imageUrl"
          class="service-image"
        />
      </div>
      <div [innerHTML]="item.htmlName" class="rendered-html"></div>
    </div>
  </ng-template>

  <ng-template footerTemplate>
    <div (click)="onCancel($event)" class="load-more-button">
      <cue-icon [icon]="cueClose" />
      <p>{{ translation.scheduler.cancel | transloco }}</p>
    </div>
  </ng-template>
</assist-dropdownlist>
